import { Validator } from '@vista-digital/validator';
import { defaultSitePickerAssets, sitePickerAssetsValidator } from './assets';
import { defaultSitePickerDisplayText, sitePickerDisplayTextValidator } from './display-text';
export const sitePickerPropsValidator = Validator.object({
    displayText: sitePickerDisplayTextValidator,
    assets: sitePickerAssetsValidator
});
export const defaultSitePickerProps = {
    displayText: defaultSitePickerDisplayText,
    assets: defaultSitePickerAssets
};
